<template>
    <v-app>
        <div id="iq3-application">
            <annotation-feature/>
            <audio-conference-feature/>
            <kinematics-feature/>
            <on-boarding-tutorial-feature/>
            <training-feature />
            <selection-feature/>
            <wait-for-confirmation/>
            <!-- Training menu display for non-VR mode -->
            <training-menu-display/>
        </div>
    </v-app>
</template>

<script>
    import AnnotationFeature from './features/annotation'
    import AudioConferenceFeature from './features/audioConference'
    import KinematicsFeature from './features/kinematics'
    import OnBoardingTutorialFeature from './features/onBoardTutorial'
    import TrainingFeature from './features/training';
    import SelectionFeature from './features/model/selection-feature'
    import WaitForConfirmation from './features/user/wait-for-confirmation'
    import TrainingMenuDisplay from './features/training/menu/menu-display.vue'

    export default {
        name: 'Iq3Application',
        components: {
            WaitForConfirmation,
            AnnotationFeature,
            AudioConferenceFeature,
            KinematicsFeature,
            OnBoardingTutorialFeature,
            TrainingFeature,
            SelectionFeature,
            TrainingMenuDisplay
        }
    }
</script>

<style>
    :not(.blocking) > .vm--modal {
        overflow: visible !important;
    }

    :not(.blocking) > .vm--container {
        pointer-events: none;
    }

    :not(.blocking) > .vm--container > .vm--overlay {
        background: transparent;
    }

    :not(.blocking) > .vm--container > .vm--modal {
        pointer-events: all;
    }

    .v-expansion-panel-content__wrap {
        padding: 0 16px !important;
    }

    .v-expansion-panel-content {
        padding-bottom: 16px !important;
    }

    .v-expansion-panel-header {
        padding: 8px 24px !important;
        min-height: 48px !important;
    }


    .relativeContainer {
        position: relative;
    }

    .helpIcon {
        width: 24px;
        height: 100%;
    }

    .helpText {
        padding: 15px;
        background-color: #2E2E2E;
        position: absolute;
        left: 120%;
        top: 100%;
        bottom: auto;
        opacity: 0;
        display: none;
        transition: 0.1s;
        width: 25rem;
        border-radius: 10px;
        z-index: 99;
    }

    .helpIcon:hover + .helpText {
        display: block;
        opacity: 1;
        transition: 0.25s;
        transition-delay: 0.25s;
    }

    .settingsIcon {
        margin: 50% 0;
    }

    .settingsMenu {
        padding: 15px;
        background-color: #2E2E2E;
        position: absolute;
        left: 100%;
        top: 80%;
        bottom: auto;
        display: none;
        width: 15rem;
        border-radius: 10px;
        border:2px solid #001400;
        z-index: 99;
    }

    .settingsMenu.active {
        display: block;
    }
</style>
